import script from "./MainHome.vue?vue&type=script&setup=true&lang=js"
export * from "./MainHome.vue?vue&type=script&setup=true&lang=js"

import "./MainHome.vue?vue&type=style&index=0&id=224fe78d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-224fe78d"]])

export default __exports__
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QSkeleton from 'quasar/src/components/skeleton/QSkeleton.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import QBadge from 'quasar/src/components/badge/QBadge.js';
import QImg from 'quasar/src/components/img/QImg.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBtn,QCard,QSkeleton,QCardSection,QSeparator,QBadge,QImg,QIcon});
